import React from "react";
import { useSidebar } from "../context/SidebarContext";
import styles from "./Header.module.css";

const Header = () => {
  const { isOpen } = useSidebar();

  return (
    <header
    className={`${styles.header}`}
    style={{
      position: "fixed",
      top: 0,
      left: isOpen ? "240px" : "64px",
      right: 0,
      height: "60px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 15px",
      backgroundColor: "#dfe0e0", /* Fondo azul vibrante */
      color: "#0e0d0d",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      transition: "left 0.3s ease",
  
    }}
  >
    {/* <h1 className={styles.title}>Panel de Administración</h1> */}
  </header>
  
  );
};

export default Header;